import React from 'react'
import { Link, useLocation } from 'react-router-dom'

export default function Breadcrumbs() {
    const location = useLocation();

    let currentLink = '';
    const crumbs = location.pathname.split('/')
        .filter(crumb => crumb !== '')
        .map(crumb => {
            currentLink += `/${crumb}`

            return (
                <div className='breadcrumb-item' key={crumb}>
                    <Link to={currentLink}>{crumb}</Link>
                </div>
            )
        })

  return (
    <div className='breadcrumb'>
        {crumbs}        
    </div>
  )
}
